module.exports = __webpack_public_path__ + "img/ellipse_blue_small.8ad95077.png";